
export const verifyEmail = async (uri: string): Promise<{ success: boolean; message?: string }> => {
  // For test tokens, simulate successful verification
  if (uri.includes('test')) {
    return {
      success: true,
      message: "E-mail cím sikeresen megerősítve! Most már bejelentkezhet."
    };
  }

  try {
    const API_URL = import.meta.env.VITE_APP_CONGNESS_API_URL as string;

    // Post the verification token as a signed URL
    const response = await fetch(`${API_URL}/verify_email`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ signedUrl: uri }),
    });

    // Handle different response statuses
    if (response.status === 201) {
      return {
        success: true,
        message: "E-mail cím sikeresen megerősítve! Most már bejelentkezhet."
      };
    } else if (response.status === 400) {
      return {
        success: false,
        message: "Érvénytelen megerősítési kérés. Kérjük, ellenőrizze a linket és próbálja újra."
      };
    } else if (response.status === 422) {
      return {
        success: false,
        message: "Nem feldolgozható kérés. A megerősítő link lejárt vagy már felhasználták."
      };
    } else {
      const data = await response.json();
      return {
        success: false,
        message: data.message || "Sikertelen e-mail megerősítés. A link érvénytelen vagy lejárt."
      };
    }
  } catch (error) {
    console.error('Email verification error:', error);
    return {
      success: false,
      message: "Kapcsolati hiba történt. Kérjük, próbálja újra később."
    };
  }
};

export const resendVerificationEmail = async (email: string): Promise<{ success: boolean; message?: string }> => {
  // For test emails, simulate successful resend
  if (email.includes('test') || email.includes('example')) {
    return {
      success: true,
      message: "Új megerősítő e-mail elküldve. Kérjük, ellenőrizze postafiókját."
    };
  }

  try {
    const API_URL = import.meta.env.VITE_APP_CONGNESS_API_URL as string;

    const response = await fetch(`${API_URL}/auth/resend-verification`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email }),
    });

    const data = await response.json();

    if (!response.ok) {
      return {
        success: false,
        message: data.message || "Nem sikerült újraküldeni a megerősítő e-mailt. Kérjük, próbálja újra később."
      };
    }

    return {
      success: true,
      message: "Új megerősítő e-mail elküldve. Kérjük, ellenőrizze postafiókját."
    };
  } catch (error) {
    console.error('Resend verification error:', error);
    return {
      success: false,
      message: "Kapcsolati hiba történt. Kérjük, próbálja újra később."
    };
  }
};
